var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_190)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7929 6.75L27.2264 29.25H24.1469L8.7134 6.75H11.7929ZM12.9779 4.5H4.44141L22.9619 31.5H31.4984L12.9779 4.5Z",
    fill: "#030322"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3964 16.496L30.7499 4.5H27.9651L18.9747 14.9163L20.3964 16.496ZM16.8553 20.5987L15.5604 18.8721L4.66113 31.5H7.44663L16.8553 20.5987Z",
    fill: "#030322"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLink);
export default __webpack_public_path__ + "static/media/X_Link.976d9938b56776dc0111ebe94c1d41fa.svg";
export { ForwardRef as ReactComponent };